import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";
import {IPresenter} from "@/rawdogjs/src/interfaces/IPresenter";
import {HomeMenuView} from "./homeMenuView";
import {Router} from "@/rawdogjs/src/router";
import {UserStore} from "../../../data/stores/UserStore";
import {TenantProfileStore} from "../../../data/stores/TenantProfileStore";
import {BookingStore} from "../../../data/stores/BookingStore";
import TimeSpan from "../../../shared/TimeSpan";

export class HomeMenuPresenter implements IPresenter {

    public _view: HomeMenuView;
    private _dependencyContainer: ParcelDependencyContainer;
    private _router: Router;
    private _userStore: UserStore;
    private _bookingStore: BookingStore;

    constructor(homeView: HomeMenuView, router: Router, dependencyContainer: ParcelDependencyContainer) {
        this._view = homeView;
        this._dependencyContainer = dependencyContainer;
        this._router = router;
    }

    async initialize() {

        this._view.bind(this, async () => {        });

        this._userStore = this._dependencyContainer.resolve<UserStore>('UserStore');
        this._bookingStore = this._dependencyContainer.resolve<BookingStore>('BookingStore');

        if (this._userStore.getDisplayName())
            this._view.displayName = this._userStore.getDisplayName();

        if (this._userStore.getEmail())
            this._view.handle = `${this._userStore.getEmail()}`;

        let booking = this._bookingStore.getBooking();

        if (!booking) {
            await this._bookingStore.pull(async (currentBooking) => {
                booking = currentBooking;
            });
        }
        
        if(booking?.bookingDate && booking?.bookingTime && booking?.address) {
            this.setBooking(booking);
            this._view.showScheduleEstimate(false);
        }
        else{
            this._view.showScheduleEstimate(true);
        }

    
        
        this._view.showLoggedIn(this._userStore.getTenantId() != null);

        // userStore.displayName$.subscribe((displayName)=>{
        //     this._view.displayName = displayName    
        // })

        const tenantProfileStore = this._dependencyContainer.resolve<TenantProfileStore>('TenantProfileStore');
        const bookingId = tenantProfileStore.getTenantProfile()?.currentWorkingBookingId;

        this._view.addOnClickHandler('#schedule-time', async () => {
            this._router.navigate(`/#/drywallio/schedule-date?id=${bookingId}`);
        })

        // const confettiHelper = new ConfettiHelper();
        // confettiHelper.start(3000)

        this._view.scrollToTop();
    }

    private setBooking(currentBooking: any) {
        if (currentBooking.bookingDate && currentBooking.bookingTime) {
            const date = this.getCombinedDateTime(currentBooking.bookingDate, currentBooking.bookingTime);
            if (date) {
                this._view.setUpcomingDate(this.formatDate(date));
                this._view.setUpcomingTime('at ' + this.formatTime(date));
                this._view.showUpcomingDate(true);
            }
        } else {
            this._view.showUpcomingDate(false);
        }
    }


    getCombinedDateTime(bookingDate, bookingTime) {
        if (!bookingDate || !bookingTime)
            return null;

        const value = new Date(bookingDate).getTime() + TimeSpan.fromString(bookingTime).getTotalMilliseconds();

        return new Date(value);
    }

    // todo: move these methods
    private formatDate(date) {
        const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
        return date.toLocaleDateString('en-us', options);
    }

    private formatTime(date: Date) {
        return date.toLocaleTimeString([], {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });

        // const formattedTime = date.toLocaleTimeString([], {
        //     hour: 'numeric',
        //     minute: '2-digit',
        //     hour12: true // Use false for 24-hour format
        // });
    }


    inject() {
    }

}

